<sb-login class="sb-frontpage" (loginEmitter)="selectedOption($event)" [loginOptions]="authOptions">
  <ng-template #login *ngIf="!!classicLoginOption">
    <div class="tw-w-full">
      <form (submit)="onSubmit(classicLoginOption)" [formGroup]="form" class="needs-validation tw-w-full tw-flex tw-flex-col tw-items-center">
        <div class="tw-w-full tw-space-y-3">
          <div>
            <input class="tw-w-full tw-input placeholder:!tw-text-white" type="text" autocomplete="username" formControlName="username"
                   [placeholder]="'lang.login.username' | translate"/>
            <div class="tw-text-sbRed-500 tw-transition-all tw-duration-200 tw-ease-in-out tw-h-0 tw-opacity-0"
                 [ngClass]="{'tw-h-5 tw-opacity-100': submitted && username.errors?.required}">
              {{'lang.login.usernameWarning' | translate}}
            </div>
          </div>
          <div>
            <input class="tw-w-full tw-input placeholder:!tw-text-white" type="password" autocomplete="current-password"
                   formControlName="password"
                   [placeholder]="'lang.login.password' | translate"/>
            <div class="tw-text-sbRed-500 tw-transition-all tw-duration-200 tw-ease-in-out tw-h-0 tw-opacity-0"
                 [ngClass]="{'tw-h-5 tw-opacity-100': submitted && password.errors?.required}">
              {{'lang.login.passwordWarning' | translate}}
            </div>
          </div>
          <a [queryParams]="{ username: username.value }" [sbRouterLink]="util.RoutingID.passwordReset"
               class="link text-white font-weight-bold">{{'lang.login.forgottenPassword' | translate}}</a>
        </div>
        <button
          sb-button-primary
          color="blue"
          class="tw-mt-8 tw-w-full"
          type="submit">
          {{'lang.login.login' | translate}}
        </button>
      </form>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="tw-text-sm tw-flex tw-flex-wrap tw-gap-2 tw-items-center tw-justify-center tw-text-sbGray-800">
            <span>
              {{getBackendName()}} {{getBackendVersion() ? getBackendVersion() : '???'}}
            </span>
      <span class="d-none d-sm-block">
              ||
            </span>
      <span>
      {{getFrontendName()}} {{getFrontendVersion() ? getFrontendVersion() : '???'}}
            </span>
    </div>
  </ng-template>

  <ng-template #message>
    <div class="tw-h-0 tw-transition-all tw-ease-in-out tw-duration-200" [ngClass]="{ 'tw-h-28': isAuthenticationFailed || hasLoggedOut || form.errors?.serverError }">
      <div *ngIf="isAuthenticationFailed || form.errors?.serverError" class="tw-flex tw-flex-col tw-text-sbRed-500 tw-space-y-2">
        <span class="font-weight-bold tw-text-xl">{{'lang.auth.failed'|translate}}</span>
        <span>{{'lang.auth.failedMessage'|translate}}</span>
      </div>
      <div *ngIf="hasLoggedOut" class="tw-text-white">
        <p class="font-weight-bold tw-text-xl">{{'lang.auth.logout'|translate}}</p>
        <div *ngIf="hasIDPOption">{{'lang.auth.logoutMessage'|translate}}</div>
      </div>
    </div>
  </ng-template>
</sb-login>
